export const reset = () => {}

// eslint-disable-next-line no-unused-vars
export const capture = (eventName, options = {}) => {}

export const record = () => {}

export const stopRecording = () => {}

export const isFeatureEnabled = () => true

export const getFeatureFlag = () => null

export const isFeatureFlagEnabled = (featureName, featureValue) => {
  const featureFlagValue = getFeatureFlag(featureName)
  return featureFlagValue === featureValue
}

export const getSurvey = () => Promise.resolve(null)
